import { inject, Injectable } from '@angular/core';
import { SwalService } from './swal.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class HandleErrorsService {
  private swalService = inject(SwalService);
  private translate = inject(TranslateService);

  /**
   * Handle a specific error by translation key.
   * @param messageKey Translation key (e.g. SWAL.FETCH_TESTS_ERROR)
   */
  handle(messageKey: string): void {
    const message = this.translate.instant(messageKey);
    this.swalService.error(message);
  }

  /**
   * Show a generic fallback error message.
   */
  handleGeneric(): void {
    const fallback = this.translate.instant('SWAL.GENERIC_ERROR');
    this.swalService.error(fallback);
  }

  /**
   * Optional: Log error to server or external tool (Sentry, etc.)
   */
  log(error: any): void {
    console.error('Captured error:', error);
    // TODO: Send error to backend or monitoring service
  }
}
